import { base } from "./_internal";

/**
 * PlanRestrictionError
 */
export class PlanRestrictionError extends base.ApplicationError {
	public static override readonly code: number = 458;

	public readonly content: string;

	constructor(message?: string, content?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Plan error");
		Object.setPrototypeOf(this, trueProto);
		this.content = content;
	}
}
